import module from 'fan/proyectos/module.js'
import template from './template.html'

export class FanProyectosComponent {
  constructor(FanProyectosService) {
    this.FanProyectosService = FanProyectosService
    this.error = null
    this.filtro = ''
  }

  $onInit() {
    this.$promise = this.FanProyectosService.get()
      .then((response) => (this.data = response.data))
      .catch((response) => (this.error = response.data))
  }
}

module.component('fanProyectos', {
  controller: FanProyectosComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fan/proyectos/components/component.js